import { render, staticRenderFns } from "./CreateEditStory.vue?vue&type=template&id=6368d1f9"
import script from "./CreateEditStory.vue?vue&type=script&lang=js"
export * from "./CreateEditStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports